import { render, staticRenderFns } from "./alarmControl.vue?vue&type=template&id=165a3b65&"
import script from "./alarmControl.vue?vue&type=script&lang=js&"
export * from "./alarmControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports